const ALLOWED_KEYS = ['Backspace', 'ArrowLeft', 'ArrowRight', 'Delete', 'Tab'];

export function allowOnlyDigits(event: KeyboardEvent): void {
  const key = event.key;
  if (!/^\d$/.test(key) && !ALLOWED_KEYS.includes(key)) {
    event.preventDefault();
  }
}
